import angular from 'angular';
import './bd-overlay-title.styles.scss';

const BackdropOverlayTitleTemplate = /* html */ `
  <div class="backdrop-overlay-title">
    <button class="btn-lvl3 light" ng-click="$ctrl.exit()">
      <!--<svg class="ab-icon"><use xlink:href="#btn-times-default"></use></svg>-->
      <i class="fa-solid fa-arrow-left"></i>
    </button>

    <h1>{{ $ctrl.title }}</h1>

    <div class="additional-content" ng-transclude></div>
  </div>
`;

export const BackdropOverlayTitleComponent = {
  selector: 'bdOverlayTitle',
  bindings: {
    title: '@',
    exit: '&',
  },
  transclude: true,
  template: BackdropOverlayTitleTemplate,
};

export default angular.module('autoboard.backdropOverlayTitle', [])
  .component(BackdropOverlayTitleComponent.selector, BackdropOverlayTitleComponent)
  .name;
